export const SIRET_MASK = 'XXX XXX XXX XXXXX';
